import { ICellRendererParams } from '@mint-lib/ag-grid/community';
import { TruncateText } from '@mint-lib/tw-components';

import { RagTableType } from '../../../../types/rag.js';

const DescriptionCell = ({ data }: ICellRendererParams<RagTableType>) => {
  if (!data?.description) {
    return null;
  }

  return (
    <div className="flex h-full flex-col justify-center">
      <TruncateText>{data.description}</TruncateText>
    </div>
  );
};

export { DescriptionCell };
